import storeManager from '../store/StoreManager';
import sessionReader from '../store/readHelpers/SessionReader';
import settingsReader from '../store/readHelpers/SettingsReader';

function canSeeResultPage() {
    const { result, settings } = storeManager.getState();
    return !!result.metaData.isLoaded
        || (sessionReader.isContextExam() && settingsReader.hasSettingValue('qti2_hideResultpage', false, settings));
}

function canSeeSummaryPage() {
    const { result } = storeManager.getState();
    return !result.metaData.isLoaded || sessionReader.isOfflineMode();
}

// Only reliable after having used API GetUserResponses
function canSeeCorrectResponsesInDelivery() {
    const { result } = storeManager.getState();
    return result.metaData.isLoaded && !!result.metaData.hasAccessToCorrectResponses;
}

function canSeeScore() {
    const { result } = storeManager.getState();
    return result.metaData.isLoaded && result.metaData.showScore;
}

const aclService = {
    canSeeResultPage,
    canSeeScore,
    canSeeSummaryPage,
    canSeeCorrectResponsesInDelivery,
};

export default aclService;
